import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { BrowserRouter, createBrowserRouter, RouterProvider } from "react-router-dom";
import { store } from "./store/store";

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
const router = createBrowserRouter([
  {
    path: "*",
    element: <App />,
  },
]);
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>
);

if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register();
}
// else{
//   serviceWorkerRegistration.unregister();
// }
